export const getGenderContext = entity => {
  if (['form', 'user', 'checklist', 'place', 'event', 'non_compliance_event', 'non_compliance'].includes(entity)) {
    return 'male'
  }
  if (['service_order'].includes(entity)) {
    return 'female'
  }
  return false
}
